const featureApi = require('../../api/feature')

exports.FeatureList = App.Views.Base.extend({
  el: '.js-feature-list',
  props: {
    // 特集を取得するAPIのパス
    apiPath: '/api/feature/list.json',
    // 特集一覧のページ番号（1ページ目はserver側で取得するため2ページ目から）
    page: 2,
    // 1回で何件読み込むか
    count: 20,
    // 読み込み中か
    isLoading: false,
    // 最後まで読み込み済みか
    loadedLast: false,
    // Loading画像の要素
    $loader: null
  },
  initialize: function() {
    const _this = this
    _this.props.$loader = $('.js-loader')

    // 初期表示
    const features = App.vars.features
    features.forEach(function(data) {
      _this.$el.append(new FeatureListItem().render(data).$el)
    })
  },
  load: function() {
    const _this = this

    if (_this.props.isLoading || _this.props.loadedLast) {
      return
    }

    _this.props.isLoading = true
    _this.props.$loader.show()

    let isSponsored = undefined
    const queries = App.getUrlQueries()
    if (_.has(queries, 'is_sponsored') && ['0', '1'].includes(queries.is_sponsored)) {
      isSponsored = queries.is_sponsored
    }

    featureApi.featureList(_this.props.page, _this.props.count, isSponsored)
      .then(function(features) {
        if (features.length > 0) {
          features.forEach(function(data) {
            _this.$el.append(new FeatureListItem().render(data).$el)
          })
          _this.props.page++
        }
        if (features.length < _this.props.count) {
          // count分取得できない = 最後
          _this.props.loadedLast = true
          _this.props.$loader.hide()
        }
      })
      .fail(function(error) {
        _this.props.$loader.hide()

        if (_.has(error, 'message')) {
          alert(error.message)
        } else {
          App.networkErrorAlert()
        }
      })
      .always(function() {
        _this.props.isLoading = false
      })
  }
})

const FeatureListItem = App.Views.Base.extend({
  tagName: 'li',
  className: 'p-article-feature__list__item',
  template: require('../../../hbs/feature_list_item.hbs'),
  render: function(data) {
    if (!data.cover_image_url) {
      data.cover_image_url = data.cover_image_urls[0]
    }

    this.$el.html(this.template(data))
    return this
  }
})



// WEBPACK FOOTER //
// ./webroot/js/sp/views/feature.js